import { isPlatformBrowser } from '@angular/common';
import { Component, inject, OnInit, PLATFORM_ID, signal } from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  Router,
  RouterOutlet,
} from '@angular/router';
import { filter, take } from 'rxjs';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  title = 'FrontEndValleyCheckPivot';

  private router = inject(Router);
  private platformId = inject(PLATFORM_ID);

  isInitializing = signal(true);

  ngOnInit() {
    if (!isPlatformBrowser(this.platformId)) return;

    this.router.events
      .pipe(
        filter(
          e =>
            e instanceof NavigationEnd ||
            e instanceof NavigationCancel ||
            e instanceof NavigationError
        ),
        take(1)
      )
      .subscribe(() => this.isInitializing.set(false));
  }
}
